'use client';
import VendorPricingPlans from '@/components/vendor/VendorPricingPlans';
import { useUserStore } from '@/stores/restuarant/user';
import HeadlessModal from '@/components/shared/HeadlessModal';
import { useEffect, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import BuyPlan from '@/app/(business)/business/dash/subscriptions/components/BuyPlan';
import { restaurant, storeFront } from '@/lib/utils/routeLinks';
import { pushEvent } from '@/lib/utils/functions';
import type { PricingPlan } from '@/lib/types/restaurant/PricingPlan';

const PricingPlans = ({ pricing_plans, plans_types, digistoreUrls }: any) => {
  const router = useRouter();
  const pathname = usePathname();
  const [showBuyModal, setShowBuyModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any | null>(null);
  const [currentPlan, setCurrentPlan] = useState<any | null>(null);

  const restaurantProfile = useUserStore((state) => state.user);

  useEffect(() => {
    if (restaurantProfile) {
      const profilePlan = restaurantProfile?.related_restaurant
        ? restaurantProfile.related_restaurant?.last_subscription
        : null;
      setCurrentPlan(profilePlan);
    }
  }, [restaurantProfile]);

  const handleBuyPlan = (plan: PricingPlan) => {
    pushEvent({
      event: 'view_item',
      eventOptions: {
        currency: 'EURO',
        value: plan?.price,
        app_name: 'LENTHO',
        screen_name: 'Subscription buy page',
        items: [
          {
            item_id: plan.id,
            item_name: plan?.name,
            item_variant: plan?.billing_period,
          },
        ],
      },
    });
    if (restaurantProfile) {
      setSelected(plan);
      setShowBuyModal(true);
    } else {
      const isHotelPage =
        `/${pathname.split('/').slice(-1)[0]}` === storeFront.forHotels.de();

      router.push(
        `${restaurant.login.de()}?redirect=/business/dash/subscriptions?${encodeURIComponent(
          `buyPlan=${plan.id}&type=${isHotelPage ? 'hotels' : 'gastronomy'}`
        )}`
      );
    }
  };

  return (
    <div>
      {pricing_plans && plans_types && (
        <VendorPricingPlans
          pricing_plans={pricing_plans}
          plans_types={plans_types}
          currentPlan={currentPlan}
          handleBuyPlan={handleBuyPlan}
          digistoreUrls={digistoreUrls}
        />
      )}

      <HeadlessModal
        isOpen={showBuyModal}
        closeModal={() => {
          setShowBuyModal(false);
          setSelected(null);
        }}
        title={`Purchase plan`}
        dialogPanelClassName="md:w-[70%] lg:w-[50%]"
      >
        {selected && (
          <BuyPlan
            item={selected}
            closeModal={() => {
              setShowBuyModal(false);
              setSelected(null);
            }}
          />
        )}
      </HeadlessModal>
    </div>
  );
};

export default PricingPlans;
